<div class="bg-white">
  <app-page-header [title]="title"></app-page-header>
  <form [formGroup]="autoForecastForm" *ngIf="autoForecastForm">
    <div class="m-6">
      <div *ngIf="mode === forecastTemplateMode.Apply" class="flex bgpd mscpd">
        <app-patient-header class="flex-1" *ngIf="patient?.id" [patient]="patient"></app-patient-header>
      </div>
      <div *ngIf="mode === forecastTemplateMode.Apply">
        <mat-label>Apply Template</mat-label>
        <span class="info-icon" [matTooltip]="tooltip" matTooltipPosition="above">
          <i class="fa-solid fa-circle-question"></i>
        </span>
        <div class="template-container">
          <thera-dropdown style="width: 30%" [options]="templateDropDownValues" (optionSelected)="onTemplateSelect($event)" [placeholder]="'Select'"> </thera-dropdown>
        </div>
        <hr class="second-container mt-5 mb-7 text-dark_gray opacity-50" />
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div class="flex flex-col w-full">
          <label for="Plan By">Plan By</label>
          <thera-dropdown class="w-full" [formGroup]="autoForecastForm" [options]="planByDropdownItem" [controlName]="'planbyid'" (optionSelected)="onValueChange('planbyid', $event)" [defaultSelection]="'0'" [placeholder]="'Minutes'"> </thera-dropdown>
        </div>
        <div class="flex flex-col w-full">
          <mat-label>Discipline(s)</mat-label>
          <div class="flex flex-wrap gap-4">
            <div *ngFor="let discipline of disciplinelist">
              <mat-checkbox [checked]="selectedDisciplines.includes(discipline.value)" [disabled]="patient?.id ? !hasOpenTherapyEpisode(discipline.code) : createthroughCorpandFacility" (change)="onDisciplineChange(discipline.value, $event.checked)">
                {{ discipline.label }}
              </mat-checkbox>
            </div>
          </div>
        </div>
        <div *ngIf="mode === forecastTemplateMode.Apply" class="flex flex-col w-full">
          <mat-label>Start Date</mat-label>
          <app-date-picker [formGroup]="autoForecastForm" [controlName]="'startdate'" [minDate]="minDate"></app-date-picker>
        </div>
        <div *ngIf="mode === forecastTemplateMode.Apply"  class="flex flex-col">
          <mat-label>Duration</mat-label>
          <div class="flex gap-2">
            <thera-dropdown [defaultSelection]="selectedValue" [options]="numbers" (optionSelected)="onValueChange('duration', $event)" placeholder="Select" class="w-20"></thera-dropdown>
            <span>weeks</span>
          </div>
        </div>
      </div>
      <hr class="mt-5 mb-7 text-dark_gray opacity-60" />
      <div class="flex flex-row gap-4">
        <div class="flex flex-col w-[40%] border border-white bg-[#F3F9FD] p-4 rounded-lg shadow-md">
          <mat-label class="header-value">Assign Minutes</mat-label>
          <app-input [onlyPositive]="true" [minLength]="3" [maxLength]="3" formControlName="assignedValue" (onKeyUp)="assignedValue()" placeholder="Enter Minutes"></app-input>
          <div *ngFor="let discipline of disciplinelist" class="flex items-center gap-x-4 mb-2">
            <mat-checkbox 
              [checked]="tempSelectedDisciplines?.includes(discipline.value)" 
              [disabled]="!tempSelectedDisciplines.includes(discipline.value)" 
              (change)="onDisciplineChangeBasedonMode(discipline.value, $event.checked)">
              {{ discipline.label }}
            </mat-checkbox>
            <div class="flex gap-x-4">
              <div *ngFor="let modeslist of modes">
                <mat-checkbox 
                  [checked]="tempSelectedModes[discipline.value]?.includes(modeslist.value) || false" 
                  (change)="onModeChange(discipline.value, modeslist.value, $event.checked)" 
                  [disabled]="!tempSelectedDisciplines.includes(discipline.value)">
                  {{ modeslist.label }}
                </mat-checkbox>
              </div>
            </div>
          </div>
          <div class="flex flex-wrap gap-x-4 border border-white rounded-lg p-2">
            <mat-radio-group formControlName="selectedOptionControl">
              <mat-radio-button *ngFor="let action of weekordayoptions"  (click)="OnWeekdayschanged(action.value)" [value]="action.value">
                {{ action.label }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="weekdays-container border border-white rounded-lg p-2">
            <div *ngFor="let weeks of Weekslist">
              <mat-checkbox (change)="OnselectWeeklist(weeks.value, $event)" [checked]="selectedWeekdays.includes(weeks.value)">
                {{ weeks.label }}
              </mat-checkbox>
            </div>
          </div>
          <div class="flex justify-end w-full mt-4">
            <thera-button
              [disabled]="isAssign"
              class="mr-2"
              (clicked)="Assigncontrols({ value: autoForecastForm.get('assignedValue')?.value })"
              [config]="{
                text: 'Assign',
                variant: buttonVariant.SECONDARY_OUTLINE
              }"></thera-button>
          </div>
        </div>
        <div class="vl"></div>
        <div class="flex flex-row w-[70%] p-4 border border-gray bg-gray">
          <div class="w-full flex flex-col">
            <div class="grid grid-cols-4 gap-18 text-center">
              <div></div>
              <div *ngFor="let discipline of disciplinelist">
                <span class="font-bold text-gray-800" style="padding-right: 27%;">{{ discipline.label }}</span>
                <div class="align-modes pb-0 flex gap-6 text-center">
                  <div *ngFor="let modeslist of modes" class="header-value">
                    {{ modeslist.label }}
                  </div>
                </div>
              </div>
            </div>

            <div *ngFor="let week of Weekslist" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-4 md:gap-6 p-4 items-center">
              <div class="font-medium text-center md:text-left">{{ week.label }}</div>
              <ng-container>
                <ng-container *ngFor="let discipline of disciplinelist">
                  <div class="flex flex-wrap gap-2 justify-center md:justify-start">
                    <ng-container *ngFor="let mode of modes">
                      <div class="flex gap-2">
                        <app-input
                          class="p-0 pt-1 w-16 sm:w-14 md:w-12"
                          placeholder="0"
                          [onlyPositive]="true"
                          [maxLength]="3"
                          type="text"
                          [formControlName]="getFormControlName(week.value, discipline.value, mode.value)"
                          (valueChange)="onassignvaluechange($event, discipline.value, mode.value, week.value)">
                        </app-input>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-5 mb-7 text-dark_gray opacity-60" />
      <div *ngIf="mode === forecastTemplateMode.Apply">
        <div class="bgpd mscpd">
          <p class="ptxt flex gap-10">
            <span *ngIf="methodologyId == payorMethodology.MEDICARE && hundredthDay">100th day is {{ hundredthDay | date : "MM/dd/yyyy" }}. This is {{ weeksFromToday }} weeks from today.</span>
            <span>Last Estimated Tx</span>
            <span>PT : {{ hasOpenTherapyEpisode(appConstants.PT)? (lastEstDates.PT ? (lastEstDates.PT | date : appConstants.MMDDYYYY) : appConstants.doublehyphen) : appConstants.doublehyphen }}</span>
            <span>OT : {{ hasOpenTherapyEpisode(appConstants.OT)? (lastEstDates.OT ? (lastEstDates.OT | date : appConstants.MMDDYYYY) : appConstants.doublehyphen) : appConstants.doublehyphen }}</span>
            <span>ST : {{ hasOpenTherapyEpisode(appConstants.ST)? (lastEstDates.ST ? (lastEstDates.ST | date : appConstants.MMDDYYYY) : appConstants.doublehyphen) : appConstants.doublehyphen }}</span>
          </p>
        </div>
      </div>
      <hr class="mt-5 mb-7 text-dark_gray opacity-50" />

      <div *ngIf="mode === forecastTemplateMode.AddOrEdit">
        <mat-label class="header-value">Save as Template</mat-label>
        <div>
          <p>Enter a template name if you would like to use these settings for future planning.</p>
          <app-input [maxLength]="75" class="dropdown-item" formControlName="name" (valueChange)="onValueChange('name', $event)" placeholder="Enter template name"></app-input>
        </div>
        <hr class="mt-14 mb-8 p-5 hrc" />
      </div>

      <div class="p-10 float-right">
        <thera-button
          class="mr-2"
          (click)="onCancel()"
          [config]="{
            text: 'Cancel',
            variant: buttonVariant.SECONDARY_OUTLINE
          }"></thera-button>
        <thera-button *ngIf="mode === forecastTemplateMode.AddOrEdit" class="mr-2" (clicked)="onSave()" [disabled]="!isSaveEnabled" 
        [config]="{ text: 'Save', variant: buttonVariant.SECONDARY }"></thera-button>
        <thera-button *ngIf="mode === forecastTemplateMode.Apply" class="mr-2" (click)="onApply()" [config]="{ text: 'Apply', variant: buttonVariant.SECONDARY }"></thera-button>
      </div>
    </div>
  </form>
</div>
